import TransferSelectTree from './TransferSelectTree';

export default TransferSelectTree;


// WEBPACK FOOTER //
// ./src/components/TransferSelectTree/index.js